/** Import components */

import GridItem from "./Item/TyreGrid";

import ListItem from "./Item/TyreList";


/**
 * 
 * @param { layout, products } param0 
 * 
 * @returns Product catalog item component
 * 
 */

const Products = ( { layout, products, notice, visualMarkup } ) => {

    /** Return component */

    return ( <div className={ `products ${ layout }` }>

        { products.map ( ( product, index ) => {

            if ( layout === "grid" ) return <GridItem 
        
                product={ product.node } 
            
                key={ "G" + index }

                visualMarkup={ visualMarkup }
                
                notice={ notice } />

            if ( layout === "list" ) return <ListItem 
        
                product={ product.node } 
            
                key={ "L" + index }

                visualMarkup={ visualMarkup }
                
                notice={ notice } />

            return null;

        } ) }

    </div> );

}

/** Export component */
 
export default Products;